import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { map } from "lodash"
import TablePagination from "@mui/material/TablePagination"
import { formatLabel } from "helpers/securities"
import PositionsRow from "./positions-row"
import PositionsTableHeader from "./positions-table-header"
import PositionTooltip from "components/position-tooltip"

class PositionsTable extends Component {
  getPositionClickHandler = (position) => {
    return () => {
      const { openCompositeSecurity, openSecurityProfile } = this.props
      const { assetClass, ticker, mic, id } = position

      if (assetClass === "index") {
        openCompositeSecurity({ type: assetClass, id })
      } else {
        openSecurityProfile(mic, ticker)
      }
    }
  }

  render() {
    const {
      items,
      columns,
      data,
      positionsSorting,
      setPositionsSorting,
      positionsPagination,
      showPositionsPage,
      fixedItemNumber,
      isActive,
    } = this.props

    return <>
      <div className={classNames("position-row header", { "fixed-item-number": fixedItemNumber })}>
        <PositionsTableHeader setPositionsSorting={setPositionsSorting} positionsSorting={positionsSorting} index="id" label="ID" />
        {map(columns, (column, i) =>
          <PositionsTableHeader
            key={i}
            setPositionsSorting={setPositionsSorting}
            positionsSorting={positionsSorting}
            index={i}
            label={column.label}
          />,
        )}
      </div>
      {map(items, (position, idx) => <div className={classNames("position-row", { "fixed-item-number": fixedItemNumber })} key={`position-${idx}`}>
        <div
          className={classNames("position-label", { disabled: !position.ticker || position.isUnmodeled })}
          onClick={!position.isUnmodeled ? this.getPositionClickHandler(position) : null}
        >
          <PositionTooltip position={position}>
            {/* The extra div here is to make the tooltip hover zone match the clickable zone */}
            <div>{formatLabel(position)}</div>
          </PositionTooltip>
        </div>
        {map(columns, (column, index) =>
          <PositionsRow key={index} column={column} data={data} item={position} index={index} isActive={isActive} />,
        )}
      </div>,
      )}
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={positionsPagination.total}
        rowsPerPage={positionsPagination.rowsPerPage}
        page={positionsPagination.page}
        onPageChange={showPositionsPage}
      />
    </>
  }
}

PositionsTable.propTypes = {
  items: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  positionsSorting: PropTypes.object.isRequired,
  setPositionsSorting: PropTypes.func.isRequired,
  positionsPagination: PropTypes.object.isRequired,
  showPositionsPage: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  fixedItemNumber: PropTypes.bool,
  isActive: PropTypes.bool.isRequired,
}

export default PositionsTable
